import { Component, OnInit ,OnDestroy} from '@angular/core';
import { FacultyService } from '../../Services/faculty.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
@Component({
  selector: 'app-faculty-details',
  templateUrl: './faculty-details.component.html',
  styleUrls: ['./faculty-details.component.scss']
})
export class FacultyDetailsComponent implements OnInit,OnDestroy {
  subscription = new Subscription();
  constructor(private facultyService: FacultyService, private route: ActivatedRoute, private router: Router, public appComponent: AppComponent) { }
  facultydetail: any = [];
  facultyname: any;
  url: any;
  FacebookLink: any;
  InstagramLink: any;
  isLoading: boolean = false;
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.route.paramMap.subscribe(params => {
      this.facultyname = params.get('seoname');
    });

    this.getFaculty(this.facultyname);
  }
  getFaculty(seoname) {
    this.isLoading = true;
    this.subscription = this.facultyService.GetFacultyData(seoname).subscribe(data => {
      this.isLoading = false;
      if (data != null) {
        this.facultydetail.push(data.Response.Data.Faculty);
      }
    }, err => {
      console.log('err in faculty-detail component', err);
      this.isLoading = false;
    });
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  onNavigate(Link) {
    if (Link == null || Link == '') {
      return;
    }
    else {
      window.open(Link);
    }
  }
}
